import { FC, RefObject, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { FormHandles } from '@unform/core';
import Autocomplete from 'src/components/Form/Autocomplete';
import DatePickerOperator from 'src/components/Form/DatePickerOperator';
import Select from 'src/components/Form/Select';
import { Item } from 'src/components/Form/Select/interfaces';
import TextField from 'src/components/Form/TextField';
import { IPartner } from 'src/interfaces/models';
import api from 'src/services/api';
import { handleApiResponseErrors } from 'src/utils/errors';
import { objectToQuery, queryToObject } from 'src/utils/helpers';

interface FilterProps {
  formRef?: RefObject<FormHandles>;
}

const statusItems: Item[] = [
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const Filters: FC<FilterProps> = ({ formRef }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [partners, setPartners] = useState<IPartner[]>([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const queryParams = objectToQuery({
          order_by: [
            { column: 'status', direction: 'asc' },
            { column: 'display_name', direction: 'asc' },
          ],
        });
        const { data } = await api.get<IPartner[]>(
          `admin/partners${queryParams}`,
        );
        setPartners(data);
      } catch (error) {
        handleApiResponseErrors(error.response, 'Erro ao buscar parceiras.');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (!partners.length) return;
    const query = new URLSearchParams(location.search);
    const params = queryToObject(query);
    if (params.partner_id) {
      formRef?.current?.setFieldValue('partner_id', params.partner_id);
    }
  }, [partners, location.search, formRef]);

  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Autocomplete
          name="partner_id"
          label="Parceira"
          options={partners.map((partner) => ({
            key: partner.id,
            label: `${partner.display_name}`,
            value: partner.id,
            disabled: partner.status !== 'active',
            data: partner,
          }))}
          size="small"
          loading={loading}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField name="name" label="Nome" size="small" />
      </Grid>

      <Grid item xs={12}>
        <DatePickerOperator
          name="start_at"
          label="Ínicio"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid>

      <Grid item xs={12}>
        <DatePickerOperator
          name="end_at"
          label="Fim"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid>

      <Grid item xs={12}>
        <Select name="status" label="Status" items={statusItems} size="small" />
      </Grid>
    </>
  );
};

export default Filters;
